import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { EvaluationSheetResultItemFieldsFragment } from '../../../../../../../../../../../../generated/core-api/graphql-react-query';

type FactCheckModuleResultItem = Extract<
  EvaluationSheetResultItemFieldsFragment,
  { __typename: 'EvaluationSheetResultFactCheckModuleItem' }
>;

interface FactCheckRunDetailsAccordionProps {
  item: FactCheckModuleResultItem;
}

export default function FactCheckRunDetailsAccordion(props: FactCheckRunDetailsAccordionProps) {
  const { item } = props;
  const { t } = useTranslation('session');
  const results = item.run?.results.items ?? [];

  if (results.length === 0) {
    return <span>{item.factCheckModule.name}</span>;
  }

  return (
    <Accordion
      disableGutters
      elevation={0}
      square
      className="fact-check-accordion"
    >
      <AccordionSummary
        expandIcon={<ExpandMore fontSize="small" />}
        className="fact-check-summary"
      >
        {item.factCheckModule.name}
      </AccordionSummary>
      <AccordionDetails className="fact-check-details">
        {results.map((result) => (
          <div className="attribute-line" key={result.id}>
            <Typography className="attribute-label">
              {result.assignee.label}
            </Typography>
            <Typography className={clsx('attribute-verdict', result.status)}>
              {t(`details.evaluation-sheets.fact-check.verdict.${result.status}`)}
            </Typography>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}
